// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"2cb4af44","55":"6168b6f4","171":"666d268c","206":"72a0267e","322":"8f0c35b5","400":"a7336882"}[chunkId] + ".chunk.js";
};